
    import '/opt/buildhome/repo/packages/x/docs/react/common-props.zh-CN.md?watch=parent';
    export const toc = [];
export const frontmatter = {"title":"通用属性","toc":"menu","filename":"docs/react/common-props.zh-CN.md","lastUpdated":1765277911000,"group":{"order":4,"title":"进阶使用"},"order":1,"__autoDescription":true,"description":"Tips: 以下通用属性适用于 Ant Design X 大部分组件，不支持的组件会单独说明。"};